import { useTheme } from "@mui/material/styles";
import { Box, Typography, Dialog, DialogTitle, DialogContent, IconButton} from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";


export default function DiaCard({ open, onClose, title, content, image, sources, action }) {
   
const theme = useTheme();

    return (
     
      <Dialog 
        open={open} 
        onClose={onClose} 
        fullWidth 
        maxWidth="sm" 
        aria-labelledby="custom-dialog-title"
        aria-describedby="custom-dialog-content"
        BackdropProps={{
      sx: { backdropFilter: 'blur(8px)', backgroundColor: theme.palette.mode === "dark" ? 'rgba(0,0,0,0.5)' : 'rgba(255,255,255,0.25)' },
    }}

        sx={{ '& .MuiDialog-paper': {
              bgcolor: theme.palette.mode === "dark" ? theme.palette.background.paper : theme.palette.background.dialog,
              borderRadius: '24px',
              maxHeight: '90vh',
              display: 'flex',
              flexDirection: 'column',
            },
          }}
            >

      <DialogTitle
        id="custom-dialog-title"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: theme.palette.mode === "dark"
                ? theme.palette.background.paper
                : theme.palette.background.dialog,
          position: 'relative',
          minHeight: 56,
          py: 1,
        }}
      >
        <Typography
          variant="h4"
          component="span" // prevents invalid <h4> inside <h2>
          sx={{
            flex: 1,
            textAlign: 'center',
            color: theme.palette.text.primary,
            fontWeight: 600,
          }}
        >
          {title}
        </Typography>
      
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 16, top: 16, color: theme.palette.text.secondary, }}
        >
      
          <CloseIcon />    
          </IconButton>

        </DialogTitle>
      
         <DialogContent
            id="custom-dialog-content"
            sx={{
              bgcolor: theme.palette.mode === "dark"
                ? theme.palette.background.paper
                : theme.palette.background.dialog,
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              overflowY: 'auto',
              flex: 1,
            }}
          >
            {content && <div>{content}</div>}

            {image && <div>{image}</div>}

            {sources && (
              <Typography
                variant="h6"
                sx={{
                  px: 4,
                  fontFamily: 'Inter',
                  color: theme.palette.text.secondary,
                  fontWeight: 400,
                }}
              >
                {sources}
              </Typography>
            )}
        </DialogContent>

      </Dialog>

    );
  }